/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import {
  LooseRichTextSchema,
  type LoosenRichTextFields,
} from '../types/loose-rich-text'
import type { Equal, ExpectTrue } from '../types/validation'

import { type CTALink, CTALinkSchema } from './cta-link'
import type { RichText } from './rich-text'
import { type CTAVideo, CTAVideoSchema } from './video'

/* TypeScript */
export type ContentApiProps = {
  technicalName?: Maybe<string>
  title?: Maybe<string>
  contentText: RichText
  subtitle?: Maybe<string>
  ctaLink?: Maybe<CTALink>
  ctaVideo?: Maybe<CTAVideo>
}

/* Schemas */
export const ContentApiPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  title: z.nullish(z.string()),
  contentText: LooseRichTextSchema,
  subtitle: z.nullish(z.string()),
  ctaLink: z.nullish(CTALinkSchema),
  ctaVideo: z.nullish(CTAVideoSchema),
})

/* Schemas validation */
type TestContentProps = ExpectTrue<
  Equal<
    LoosenRichTextFields<ContentApiProps>,
    z.infer<typeof ContentApiPropsSchema>
  >
>
